import { memo, useMemo } from 'react';

import { RegistrationStepProps } from './RegistrationStep.types';
import customStepComponents from './StepComponents';
import DefaultRegistrationStep from './StepComponents/DefaultRegistrationStep';
import { Box } from '@bonanza-social/moonlight';
import RegistrationStepTracker from './RegistrationStepTracker';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectRegistrationConfig } from '../../state';

function RegistrationStep({ step, ...props }: RegistrationStepProps) {
  const StepComponent = useMemo(
    () => customStepComponents[step.id] || DefaultRegistrationStep,
    [step.id],
  );
  const config = useSelector(selectRegistrationConfig);
  const showRegistrationTracker =
    !step.disableHeader && config?.hideProgressBar;

  return (
    <Box flex={1}>
      {showRegistrationTracker ? <RegistrationStepTracker step={step} /> : null}
      <StepComponent step={step} {...props} />
    </Box>
  );
}

export default memo(RegistrationStep);
